import { render, staticRenderFns } from "./FinanceBankDetailsCards.vue?vue&type=template&id=85cf0c0a"
import script from "./FinanceBankDetailsCards.vue?vue&type=script&lang=js"
export * from "./FinanceBankDetailsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports